import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider, ThemeProvider } from "@/contexts/AppContexts";
import Analyzer from "@/pages/Analyzer";
import HistoryPage from "@/pages/History";
import HistoryDetail from "@/pages/HistoryDetail";
import Admin from "@/pages/Admin";

function App() {
  return (
    <ThemeProvider>
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Analyzer />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/history/:id" element={<HistoryDetail />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </LangProvider>
    </ThemeProvider>
  );
}

export default App;
